import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import { ToastProvider } from './contexts/toast-context';
import { LayoutVisibilityProvider } from './contexts/layout-visibillity-context';
import BlockFileUpload from './components/block-file-upload';

// FOR PRODUCTION use Sentry for error logging and monitoring
// FOR DEVELOPMENT disable Sentry to avoid unnecessary logging
// Uncomment or comment the bellow to disable or enable Sentry in development mode

// For PROD
import * as Sentry from '@sentry/react';
Sentry.init({
  dsn: import.meta.env.VITE_PUBLIC_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.consoleLoggingIntegration({ levels: ['log', 'warn', 'error'] }),
  ],
  tracesSampleRate: 1.0,
  sendDefaultPii: true,
  enableLogs: true,
});

const container = document.getElementById('root');

const root = ReactDOM.createRoot(container!, {
  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
    console.warn('Uncaught error', error, errorInfo.componentStack);
  }),
  onCaughtError: Sentry.reactErrorHandler(),
  onRecoverableError: Sentry.reactErrorHandler(),
});
root.render(
  <BrowserRouter>
    <BlockFileUpload>
      <ToastProvider>
        <LayoutVisibilityProvider>
          <App />
        </LayoutVisibilityProvider>
      </ToastProvider>
    </BlockFileUpload>
  </BrowserRouter>
);

// For DEV
// const container = document.getElementById('root');
// const root = ReactDOM.createRoot(container!);
// root.render(
//   <BrowserRouter>
//     <BlockFileUpload>
//       <ToastProvider>
//         <LayoutVisibilityProvider>
//           <App />
//         </LayoutVisibilityProvider>
//       </ToastProvider>
//     </BlockFileUpload>
//   </BrowserRouter>
// );
